import { VillaSearchPassengerCountPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-passenger-count/villa-search-passenger-count.types";
import { MaterialIcon } from "@website/icons/material";
import { CounterButton } from "@website/ui/counter-button";
import pick from "lodash-es/pick";
import { useCallback, useState } from "react";

export const useVillaSearchPassengerCount = (
  properties: VillaSearchPassengerCountPropertiesType
) => {
  const { onSubmit, result, title, list, validation } = properties;
  const [open, setOpen] = useState<boolean>(false);

  const onClickChips = useCallback(() => {
    setOpen(true);
  }, []);

  const onClosePopover = useCallback(() => {
    setOpen(false);
  }, []);

  const onClickSubmit = useCallback(() => {
    onClosePopover();
    onSubmit();
  }, [onClosePopover, onSubmit]);

  return {
    submitButtonProps: {
      onClick: onClickSubmit,
      color: "secondary" as const,
      size: "large" as const,
      fullWidth: true,
      submitText: "تایید"
    },
    chipsProps: {
      variant: "outline" as const,
      EndIcon: <MaterialIcon name="arrow_drop_down" variant="fill" />,
      text: result,
      selected: true,
      color: "secondary" as const,
      onClick: onClickChips
    },
    popoverProps: {
      onClose: onClosePopover,
      open,
      title
    },
    validation,
    miniChipsPassenger: {
      text: "سقف مجموع تعداد مسافر برای هر اتاق ۱۵ نفر می باشد."
    },
    miniChipsChildren: {
      text: "سقف تعداد کودک به ازای هر بزرگسال ۱۲ نفر می باشد"
    },
    list: list.map((item) => ({
      title: item.title,
      subtitle: item.subtitle,
      role: "default",
      EndAction: (
        <CounterButton
          color="secondary"
          variant="outline"
          {...pick(item, "decreaseDisabled", "increaseDisabled", "onChange")}
          locale="fa"
          value={item.value}
        />
      )
    }))
  };
};
